import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=159b6bab&scoped=true"
import script from "./Buscador.vue?vue&type=script&lang=js"
export * from "./Buscador.vue?vue&type=script&lang=js"
import style0 from "./Buscador.vue?vue&type=style&index=0&id=159b6bab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b6bab",
  null
  
)

export default component.exports